import Vue from "vue";
import Router from "vue-router";
import axios from "axios";
import DashboardLayout from "@/layout/DashboardLayout";
import AuthLayout from "@/layout/AuthLayout";
Vue.use(Router);

const router = new Router({
    mode: "history",
    linkExactActiveClass: "active",
    routes: [{
        path: "/dashboard",
        redirect: "dashboard",
        component: DashboardLayout,
        children: [{
            path: "/dashboard",
            name: "หน้าแรก",
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () =>
                import( /* webpackChunkName: "demo" */ "./views/Dashboard.vue"),
        },
        {
            path: "/customer",
            name: "ข้อมูลลูกค้า",
            component: () =>
                import( /* webpackChunkName: "demo" */ "./views/Customer.vue"),
        },
        {
            path: "/customerWsu",
            name: "ข้อมูลลูกค้า พรบ.",
            component: () =>
                import( /* webpackChunkName: "demo" */ "./views/CustomerWsu.vue"),
        },
        {
            path: "/customerInsurance",
            name: "ข้อมูลลูกค้า ประกัน",
            component: () =>
                import(
                    /* webpackChunkName: "demo" */
                    "./views/CustomerInsurance.vue"
                ),
        },
        {
            path: "/customerWsuAddNew",
            name: "บันทึกข้อมูลลูกค้า พรบ.",
            component: () =>
                import(
                    /* webpackChunkName: "demo" */
                    "./views/CustomerWsuAddNew.vue"
                ),
        },
        {
            path: "/customerWsuDetail/:id",
            name: "แก้ไขข้อมูลลูกค้า พรบ.",
            component: () =>
                import(
                    /* webpackChunkName: "demo" */
                    "./views/CustomerWsuDetail.vue"
                ),
        },
        {
            path: "/customerWsuView/:id",
            name: "ดูข้อมูลลูกค้า พรบ.",
            component: () =>
                import(
                    /* webpackChunkName: "demo" */
                    "./views/CustomerWsuView.vue"
                ),
        },
        {
            path: "/customerInsuranceAddNew",
            name: "บันทึกข้อมูลลูกค้า ประกัน",
            component: () =>
                import(
                    /* webpackChunkName: "demo" */
                    "./views/CustomerInsuranceAddNew.vue"
                ),
        },
        {
            path: "/customerInsuranceDetail/:id",
            name: "แก้ไขข้อมูลลูกค้า ประกัน",
            component: () =>
                import(
                    /* webpackChunkName: "demo" */
                    "./views/CustomerInsuranceDetail.vue"
                ),
        },
        {
            path: "/customerInsuranceView/:id",
            name: "ดูข้อมูลลูกค้า ประกัน",
            component: () =>
                import(
                    /* webpackChunkName: "demo" */
                    "./views/CustomerInsuranceView.vue"
                ),
        },
        {
            path: "/customerWsuReminder",
            name: "ดูใบเตือนต่ออายุ พรบ.",
            component: () =>
                import(
                    /* webpackChunkName: "demo" */
                    "./views/CustomerWsuReminder.vue"
                ),
        },
        {
            path: "/customerWsuExtend/:id",
            name: "ต่ออายุลูกค้า พรบ.",
            component: () =>
                import(
                    /* webpackChunkName: "demo" */
                    "./views/CustomerWsuExtend.vue"
                ),
        },
        {
            path: "/customerInsuranceReminder",
            name: "ดูใบเตือนต่ออายุ ประกัน",
            component: () =>
                import(
                    /* webpackChunkName: "demo" */
                    "./views/CustomerInsuranceReminder.vue"
                ),
        },
        {
            path: "/customerInsuranceHistory",
            name: "ประวัติแจ้งงานประกัน",
            component: () =>
                import(
                    /* webpackChunkName: "demo" */
                    "./views/CustomerInsuranceHistory.vue"
                ),
        },
        {
            path: "/customerInsuranceExtend/:id",
            name: "ต่ออายุลูกค้า ประกัน",
            component: () =>
                import(
                    /* webpackChunkName: "demo" */
                    "./views/CustomerInsuranceExtend.vue"
                ),
        },
        {
            path: "/receipt",
            name: "ดูใบเสร็จทั้งหมด",
            component: () =>
                import( /* webpackChunkName: "demo" */ "./views/Receipt.vue"),
        },
        {
            path: "/receipt/:id",
            name: "แก้ไขใบเสร็จ",
            component: () =>
                import( /* webpackChunkName: "demo" */ "./views/ReceiptDetail.vue"),
        },
        {
            path: "/receiptView/:id",
            name: "ดูใบเสร็จ",
            component: () =>
                import( /* webpackChunkName: "demo" */ "./views/ReceiptView.vue"),
        },
        {
            path: "/quotation/:id",
            name: "ดูใบเสนอราคา",
            component: () =>
                import( /* webpackChunkName: "demo" */ "./views/Quotation.vue"),
        },
        {
            path: "/receiptGroup/:id",
            name: "แก้ไขใบเสร็จแบบกลุ่ม",
            component: () =>
                import(
                    /* webpackChunkName: "demo" */
                    "./views/ReceiptGroupDetail.vue"
                ),
        },
        {
            path: "/receiptGroupView/:id",
            name: "ดูใบเสร็จแบบกลุ่ม",
            component: () =>
                import( /* webpackChunkName: "demo" */ "./views/ReceiptGroupView.vue"),
        },
        {
            path: "/receiptAddNew",
            name: "สร้างใบเสร็จ",
            component: () =>
                import( /* webpackChunkName: "demo" */ "./views/ReceiptAddNew.vue"),
        },
        {
            path: "/receiptAddNewGroup",
            name: "สร้างใบเสร็จแบบกลุ่ม",
            component: () =>
                import(
                    /* webpackChunkName: "demo" */
                    "./views/ReceiptAddNewGroup.vue"
                ),
        },
        {
            path: "/calculator",
            name: "คำนวนภาษี",
            component: () =>
                import( /* webpackChunkName: "demo" */ "./views/Calculator.vue"),
        },
        {
            path: "/calculator/:id",
            name: "แก้คำนวนภาษี",
            component: () =>
                import( /* webpackChunkName: "demo" */ "./views/EditCalculator.vue"),
        },
        {
            path: "/line",
            name: "รับแจ้งข้อมูลประกัน",
            component: () =>
                import( /* webpackChunkName: "demo" */ "./views/Line.vue"),
        },
        {
            path: "/document",
            name: "เอกสารสำเนาลูกค้า",
            component: () =>
                import( /* webpackChunkName: "demo" */ "./views/Document.vue"),
        },
        {
            path: "/agent",
            name: "ตัวแทน",
            component: () =>
                import( /* webpackChunkName: "demo" */ "./views/Agent.vue"),
        },
        {
            path: "/agent/:id",
            name: "ข้อมูลตัวแทน",
            component: () =>
                import( /* webpackChunkName: "demo" */ "./views/AgentDetail.vue"),
        },
        {
            path: "/agentAddNew",
            name: "เพิ่มตัวแทน",
            component: () =>
                import( /* webpackChunkName: "demo" */ "./views/AgentAddNew.vue"),
        },
        {
            path: "/documentDetail/:id",
            name: "อัพโหลด/แก้ไข เอกสาร",
            component: () =>
                import( /* webpackChunkName: "demo" */ "./views/DocumentDetail.vue"),
        },
        {
            path: "/employee",
            name: "พนักงาน",
            component: () =>
                import( /* webpackChunkName: "demo" */ "./views/Employee.vue"),
        },
        {
            path: "/employeeAddNew",
            name: "เพิ่มพนักงาน",
            component: () =>
                import( /* webpackChunkName: "demo" */ "./views/EmployeeAddNew.vue"),
        },
        {
            path: "/employee/:id",
            name: "ข้อมูลพนักงาน",
            component: () =>
                import( /* webpackChunkName: "demo" */ "./views/EmployeeDetail.vue"),
        },
        {
            path: "/logs",
            name: "ประวัติ",
            component: () =>
                import( /* webpackChunkName: "demo" */ "./views/Log.vue"),
        },
            // { path: "*",
            //   component: () => import(/* webpackChunkName: "demo" */ './views/Dashboard.vue')
            // }
        ],
    },
    {
        path: "/",
        redirect: "login",
        component: AuthLayout,
        children: [{
            path: "/login",
            name: "login",
            component: () =>
                import( /* webpackChunkName: "demo" */ "./views/Login.vue"),
        },
        { path: "*", redirect: { name: "login" } },
            // {
            //     path: '/register',
            //     name: 'register',
            //     component: () =>
            //         import ( /* webpackChunkName: "demo" */ './views/Register.vue')
            // }
        ],
    },
    ],
});

// ตรวจตัวตนเมื่อเข้าหน้าใช้งานครั้งแรกต่อ tab (sessionStorage flag)
// แก้อาการ: เครื่องที่ใช้ร่วมกัน user คนก่อนปิด browser โดยไม่ logout
// → token + name + level ค้างใน localStorage → user คนใหม่เปิด URL ตรงเข้าหน้าใช้งาน
// จะเห็น "ชื่อคนก่อน" จนกว่าจะ logout/login ใหม่
router.beforeEach(async (to, from, next) => {
    if (to.path === "/login") return next();
    if (!localStorage.token) return next();
    if (sessionStorage.identityVerified === "1") return next();

    try {
        const res = await axios.get("/api/me", {
            headers: {
                Authorization: "Bearer " + localStorage.token,
                "Cache-Control": "no-store",
                Pragma: "no-cache",
            },
        });
        if (
            res.data &&
            String(res.data.name) === String(localStorage.name) &&
            String(res.data.level) === String(localStorage.level)
        ) {
            sessionStorage.identityVerified = "1";
            return next();
        }
        localStorage.clear();
        sessionStorage.clear();
        return next({ path: "/login" });
    } catch (err) {
        localStorage.clear();
        sessionStorage.clear();
        return next({ path: "/login" });
    }
});

export default router;